<template>
    <el-row>

        <el-divider content-position="left">{{$t('message.Intro')}}</el-divider>
        <el-row>
            <el-col :span="16">
                <p>陈路, 四川大学生物治疗国家重点实验室研究员，博士生导师，国家“青年千人计划”学者</p>
            </el-col>
            <el-col :span="6" :offset="18">
                <el-image style="width: 160px; height: 180px" :src="`${publicPath}luchen.png`" :fit="fit"></el-image>
            </el-col>
        </el-row>

        <el-divider content-position="left">{{$t('message.CV')}}</el-divider>

        <el-row :gutter="20">
            <el-col :span="16">
                <el-timeline :reverse="reverse">
                    <el-timeline-item
                            v-for="(activity, index) in activities"
                            :key="index"
                            :timestamp="activity.timestamp">
                        {{activity.content}}
                    </el-timeline-item>
                </el-timeline>
            </el-col>
            <el-col :span="6">
                <el-switch
                    v-model="reverse"
                    active-text="Sort by time (asc)"
                    inactive-text="Sort by time (desc)">
                </el-switch>
            </el-col>
        </el-row>

        <el-divider content-position="left">{{$t('message.Study')}}</el-divider>
        <el-row>
            <p>疾病基因转录调控机理实验室主要运用综合基因组、转录组、表征遗传组等大数据和生物学实验等方法研究基因调控和疾病发生机理，</p>
            <p>开展选择性剪切在造血干细胞分化、癌症发生和多层面组学等领域中的研究工作，</p>
            <p>从而揭示癌症、血液病、自身免疫性等疾病的发病机理，并希望结合大数据、生物实验为疾病的诊断和治疗提供新的思路和方法。</p>
            <p>实验室负责人论文发表在Science、Cell(2篇)、Nature、Nature genetics(2篇)等国际学术期刊上共发表16篇，</p>
            <p>其中影响因子>10的论文11篇。第一作者的身份共发表论文，包括Science、Cell等。</p>
        </el-row>

        <el-divider content-position="left">{{$t('message.News')}}</el-divider>
        <el-row>
            <el-col :span="16">
                <el-timeline>
                    <el-timeline-item v-for="(n, index) in news" :key="index" :timestamp="n.timestamp" placement="top">
                        <el-card>
                            <h4 v-if="n.title !== ''">{{ n.title }}</h4>
                            <p>{{ n.content }}</p>
                        </el-card>
                    </el-timeline-item>
                </el-timeline>
            </el-col>
        </el-row>

    </el-row>
</template>

<script>
    export default {
        name: "Home",
        data() {
            return {
                publicPath: process.env.BASE_URL,
                fit: "cover",
                url: "<%= BASE_URL %>luchen.png",
                reverse: true,
                activities: [{
                    content: '四川大学华西医院生物治疗国家重点实验室，研究员',
                    timestamp: '2016 - 至今'
                }, {
                    content: '博士后 (剑桥大学，桑格研究所，英国)',
                    timestamp: '2011.6 － 2016.8'
                }, {
                    content: '博士 (巴斯大学,  英国)',
                    timestamp: '2008.10 － 2011.6'
                }],
                news: [{
                    timestamp: "2019/09/30",
                    title: "Vue",
                    content: "Upgrade this web site to vue"
                }]
            }
        }
    }
</script>

<style scoped>

</style>